import JsonUtil from '../util/JsonUtil'

export class RecommendItem {
  public id = ''
  public title = ''
  public desc = ''
  public priceString = ''
  public imgUrl = ''
  public ctUrl = ''
  public num = 0
  public rquid = ''
  public spec = ''

  constructor(
    obj: Record<string, string>,
    num: number,
    rquid: string,
    spec: string
  ) {
    this.id = obj.id
    this.title = obj.title
    this.desc = obj.desc
    this.priceString = obj.priceString
    this.imgUrl = obj.imgUrl
    this.ctUrl = obj.ctUrl
    this.num = num
    this.rquid = rquid
    this.spec = spec
  }
}

export default class RecommendResponse {
  public cat: string[] = []
  private callback = ''
  private cookie = ''
  public items: Record<string, string>[][] = []
  public recommendItems: RecommendItem[] = []
  private merch = ''
  private prod: string[] = []
  private redirect = ''
  public rqid = ''
  public spec = ''
  public paramCheckResult = ''

  public static crateRecommendResponse(
    data: Record<string, unknown>
  ): RecommendResponse {
    const obj: RecommendResponse = JsonUtil.jsonToObject<RecommendResponse>(
      RecommendResponse,
      data
    )
    let num = 0
    const useImg = obj.cat.includes('product_top')
    // パラメータ存在チェック
    obj.paramCheckResult = paramCheck(obj, useImg)
    if (obj.paramCheckResult === '') {
      // 空文字 = エラーなし
      obj.items.forEach((itemsElem) => {
        // itemsElem[0]: Record<string, unknown>, itemsElem[1]: true/false
        const item = new RecommendItem(itemsElem[0], ++num, obj.rqid, obj.spec)
        obj.recommendItems.push(item)
      })
      // 使用するパラメータの値チェック
      obj.paramCheckResult = paramValueCheck(obj.recommendItems, useImg)
    }
    return obj
  }
}

/**
 * パラメータの存在チェックを行う
 * @param obj RecommendResponse型にパースされたJsonオブジェクト
 * @param useImg img_urlを使用するか否かのフラグ
 * @returns エラーあり：項目の文字列, エラーなし：空文字
 */
const paramCheck = (obj: RecommendResponse, useImg: boolean): string => {
  const error: string[] = []
  if (obj.rqid === '') {
    error.push('rqid')
  }
  if (obj.spec === '') {
    error.push('spec')
  }
  if (obj.items.length === 0) {
    error.push('items')
  } else {
    // itemsの各要素のパラメータ存在チェック
    obj.items.forEach((itemsElem) => {
      const item = itemsElem[0]
      if (!('id' in item) || item.id === undefined) {
        error.push('id')
      }
      if (!('title' in item) || item.title === undefined) {
        error.push('title')
      }
      if (useImg) {
        if (!('imgUrl' in item) || item.imgUrl === undefined) {
          error.push('imgUrl')
        }
      }
      if (!('ctUrl' in item) || item.ctUrl === undefined) {
        error.push('ctUrl')
      }
    })
  }
  return removeDuplicate(error)
}

/**
 * パラメータの値のチェックを行う
 * @param obj itemsの中身
 * @param useImg img_urlを使用するか否かのフラグ
 * @returns エラーあり：項目の文字列, エラーなし：空文字
 */
const paramValueCheck = (obj: RecommendItem[], useImg: boolean): string => {
  const error: string[] = []
  let result = ''
  obj.forEach((e) => {
    if (!isCorrectValue(e.id)) {
      error.push('id')
    }
    if (!isCorrectValue(e.title)) {
      error.push('title')
    }
    if (useImg && !isCorrectValue(e.imgUrl)) {
      error.push('imgUrl')
    }
    if (!isCorrectValue(e.ctUrl)) {
      error.push('ctUrl')
    }
  })
  // なかったパラメータの文字列を作成(エラー通知で使用)
  const errorStr = removeDuplicate(error)
  if (errorStr.length !== 0) {
    result += result ? `,${errorStr}` : errorStr
  }
  return result
}
/**
 * 引数の配列の重複を削除し、カンマ区切りの文字列を作成する
 */
const removeDuplicate = (array: string[]): string => {
  // 重複を削除
  const uniqueList = array.filter((e, index, self) => {
    return self.indexOf(e) === index
  })
  // カンマ区切りの文字列を生成
  return uniqueList.join(',')
}

/**
 * 正常な値か否かを検証する
 * 1. 空文字
 * @param target 対象文字列
 * @return 正常：true, 異常：false
 */
const isCorrectValue = (target: string): boolean => {
  let result = true
  if (target === '') {
    result = false
  }
  return result
}
